"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.windowMetaReducerBase = void 0;
var tslib_1 = require("tslib");
var actions_1 = require("../../constants/actions");
var clientMeta_1 = require("../../utilities/clientMeta");
var windowMetaReducerBase = function (state, action) {
    if (!action) {
        return state || null;
    }
    if (action.type === actions_1.SET_WINDOW_META) {
        var values = action.values;
        return tslib_1.__assign(tslib_1.__assign({}, state), values);
    }
    if (action.type === actions_1.WINDOW_RESIZE) {
        return tslib_1.__assign(tslib_1.__assign({}, state), action.values);
    }
    if (action.type === actions_1.LOCATION_CHANGE) {
        return tslib_1.__assign(tslib_1.__assign({ platformType: clientMeta_1.clientMeta.platform }, state), { referrer: window.document.referrer });
    }
    return state || null;
};
exports.windowMetaReducerBase = windowMetaReducerBase;
